<template>
    <div>
        <div class="card-deal-params-block">
            <el-row v-if="canViewField( 'title') && isValueVisible(title, 'title')">
                <el-col :span="10">
                    <span class="gray">
                        Название
                    </span>
                </el-col>
                <el-col :span="14">
                    <template v-if="editMode && canEditField( 'title')">
                        <el-input size="mini" autocomplete="off" type="text" v-model="title" />
                        <div class="field-error" v-if="errors.title" v-text="errors.title[0]"></div>
                    </template>
                    <template v-else>
                        {{ title }}
                    </template>
                </el-col>
            </el-row>
        </div>
        <contact-card
            :contact="contact"
            :edit-mode="canEditContactField(editMode)"
            @update-contact="updateContactId"
            @update-contact-data="handleContactChange"
            v-if="isValueVisible(contact_id)"
        />
        <div class="card-deal-params-block">
            <template v-if="canViewField('address') && isValueVisible(address, 'address')">
                <el-row>
                    <el-col :span="10">
                        <span class="gray">
                            Адрес
                        </span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <template v-if="editMode && canEditField('address')">
                            <vue-suggestions-address
                                class="autocomplete-input w100"
                                v-model="address"
                                @handleAddress="handleAddress"
                                @handleCoordinates="handleCoordinates"
                                dropdown-class="deal-address-dropdown"
                            />
                            <div class="field-error" v-if="errors.address" v-text="errors.address[0]"></div>
                        </template>
                        <template v-else>
                            {{ address }}
                        </template>
                    </el-col>
                </el-row>
            </template>
        </div>
        <div class="card-deal-params-block">
            <el-row>
                <el-col :span="10">
                    <span class="gray">
                        Офис
                    </span>
                </el-col>
                <el-col :span="14">
                    <template v-if="editMode && canEditField('responsible_user_id')">
                        <el-select
                            v-model="office_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            filterable
                            clearable
                            autocomplete
                            placeholder="Офис"
                            size="mini"
                        >
                            <el-option
                                v-for="item in availableDealOffices"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                                :class="isFiredEmployerClass(item.date_fired)"
                            />
                        </el-select>
                        <div class="field-error" v-if="errors.responsible_user_id" v-text="errors.responsible_user_id[0]"></div>
                    </template>
                    <template v-else>
                        <span @click="goCard(responsible_user_id)" class="orange pointer">
                            {{ responsibleUserName }}
                        </span>
                    </template>
                </el-col>
            </el-row>
            <el-row v-if="canViewField('responsible_user_id') && isValueVisible(responsible_user_id, 'responsible_user_id')">
                <el-col :span="10">
                    <span class="gray">
                        Ответственный
                    </span>
                </el-col>
                <el-col :span="14">
                    <template v-if="editMode && canEditField('responsible_user_id')">
                        <el-select
                            v-model="responsible_user_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            filterable
                            clearable
                            autocomplete
                            placeholder="Ответственный"
                            size="mini"
                        >
                            <el-option v-for="item in responsibleList" :key="item.id" :label="item.name" :value="item.id" :class="isFiredEmployerClass(item.date_fired)" />
                        </el-select>
                        <div class="field-error" v-if="errors.responsible_user_id" v-text="errors.responsible_user_id[0]"></div>
                    </template>
                    <template v-else>
                        <span @click="goCard(responsible_user_id)" class="orange pointer">
                            {{ responsibleUserName }}
                        </span>
                    </template>
                </el-col>
            </el-row>
        </div>
        <div class="card-deal-params-block">
            <el-row v-if="canViewField( 'link_id') && isValueVisible(link_id, 'link_id')">
                <el-col :span="10">
                    <span class="gray">
                        Канал связи
                    </span>
                </el-col>
                <el-col :span="14">
                    <template v-if="editMode && canEditField( 'link_id')">
                        <el-select
                            v-model="link_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            clearable
                            placeholder="Канал связи"
                            size="mini"
                        >
                            <el-option v-for="item in linkList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                        <div class="field-error" v-if="errors.link_id" v-text="errors.link_id[0]"></div>
                    </template>
                    <template v-else>
                        {{ linkName }}
                    </template>
                </el-col>
            </el-row>
            <el-row v-if="canViewField( 'roistat') && isValueVisible(roistat, 'roistat')">
                <el-col :span="10">
                    <span class="gray">
                        roistat
                    </span>
                </el-col>
                <el-col :span="14">
                    <template v-if="editMode && canEditField( 'link_id') && link_id === localReferences.referenceLink.link_whatsapp && statusId === localReferences.dealStatuses.contactEstablished">
                        <el-input size="mini" autocomplete="off" type="text" v-model="roistat" />
                        <div class="field-error" v-if="errors.roistat" v-text="errors.roistat[0]"></div>
                    </template>
                    <template v-else>
                        {{ roistat }}
                    </template>
                    <template v-if="editMode && canEditField( 'link_id') && link_id === localReferences.referenceLink.link_whatsapp && statusId === localReferences.dealStatuses.contactEstablished">
                        <span class="gray">
                            нет roistat
                        </span>
                        <el-checkbox class="el-table-filter__checkbox-group" v-model="hasWhatsappRoistat" @change="handleHasWhatsappRoistat" />
                    </template>
                </el-col>
            </el-row>
            <el-row v-if="canViewField( 'source')">
                <el-col :span="10">
                    <span class="gray">
                        Источник
                    </span>
                </el-col>
                <el-col :span="14">
                    <template>
                        {{ source }}
                    </template>
                </el-col>
            </el-row>
        </div>
        <div v-if="custom_fields !== undefined && custom_fields.length > 0" class="card-deal-params-block">
            <div class="task-section-title">
                Дополнительные поля
            </div>
            <el-row v-for="customField in custom_fields" :key="customField.id">
                <el-col :span="10">
                    <span class="grey">
                        {{ customField.name }}
                    </span>
                </el-col>
                <el-col :span="14">
                    {{ customField.value }}
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { cardMixin } from '@/mixins/card';
import ContactCard from '@/components/ContactDealCard';
import VueSuggestionsAddress from '@/components/VueSuggestionsAddress';
import localReferences from '@/helpers/localReferences';

export default {
    name: 'Contact',
    data() {
        return {
            hasWhatsappRoistat: false
        };
    },
    mixins: [
        cardMixin
    ],
    components: {
        VueSuggestionsAddress,
        ContactCard
    },
    computed: {
        contact() {
            return this.$store.state.deals.current.contact;
        },
        officeList() {
            return this.$store.state.references.offices;
        },
        officeName() {
            if (this.editMode && this.canField(this.editMode, 'responsible_user_id')) {
                let officeId;
                if (this.responsible_user_id) {
                    const employer = this.getItemFromLisById(this.responsible_user_id, this.responsibleList);
                    officeId = employer ? employer.office_id : null;
                } else {
                    officeId = null;
                }
                return officeId ? this.getItemFromLisById(officeId, this.officeList).name : '';
            } else {
                return this.responsibleUser && this.responsibleUser.office ? this.responsibleUser.office.name : '';
            }
        },
        responsibleUser() {
            return this.$store.state.deals.current.responsible_user;
        },
        responsibleUserName() {
            return this.responsibleUser ? this.responsibleUser.full_name : '';
        },
        linkName() {
            return this.$store.state.deals.current.link ? this.$store.state.deals.current.link.name : '';
        },
        linkList() {
            return this.$store.state.references.links;
        },
        dealId() {
            return this.$store.state.deals.current.id;
        },
        contact_id: {
            get() {
                return this.$store.state.deals.current.contact_id;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'contact_id', value });
            }
        },
        date_fired: {
            get() {
                return this.$store.state.deals.current.responsible_user ? this.$store.state.deals.current.responsible_user.date_fired : '';
            }
        },
        responsible_user_id: {
            get() {
                return this.$store.state.deals.current.responsible_user_id;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'responsible_user_id', value });
            }
        },
        office_id: {
            get() {
                return this.$store.state.deals.current.office_id;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'office_id', value });
            }
        },
        availableDealOffices: {
            get() {
                return this.$store.state.auth.availableDealOffices;
            }
        },
        address: {
            get() {
                return this.$store.state.deals.current.address;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'address', value });
            }
        },
        title: {
            get() {
                return this.$store.state.deals.current.title;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'title', value });
            }
        },
        link_id: {
            get() {
                return this.$store.state.deals.current.link_id;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'link_id', value });
            }
        },
        roistat: {
            get() {
                return this.$store.state.deals.current.roistat;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'roistat', value });
            }
        },
        source: {
            get() {
                return this.$store.state.deals.current.lead ? this.$store.state.deals.current.lead.source : '';
            }
        },
        custom_fields: {
            get() {
                return this.$store.state.deals.current.custom_fields ? this.$store.state.deals.current.custom_fields : '';
            }
        }
    },
    methods: {
        goContact(id) {
            this.$router.push({ name: 'contact-card', params: { id } });
        },
        goCard(id) {
            this.$router.push({ name: 'employer-card', params: { id } });
        },
        handleContactChange(value) {
            this.$store.commit('deals/setCurrentField', { field: 'contact', value: value });
        },
        updateContactId(value) {
            this.contact_id = value;
        },
        handleAddress(value) {
            this.$store.commit('deals/setCurrentField', { field: 'address', value });
        },
        handleCoordinates(value) {
            this.$store.commit('deals/setCurrentField', { field: 'coordinates', value });
        },
        handleHasWhatsappRoistat(value) {
            this.$store.commit('deals/setCurrentField', { field: 'has_roistat', value });
        },
        handleResponsibleEmployerChange(employerId) {
            const employer = this.$store.state.references.employers.filter(employer => employer.id === employerId);
            console.log(employer);
            if (employer.length !== -1) {
                console.log('here');
                return this.isFiredEmployerClass(employer[0].date_fired);
            }
        }
    },
    mounted() {
        if (this.dealId === null && this.responsible_user_id === null) {
            this.responsible_user_id = this.$store.state.auth.employerId;
        }
    }
};
</script>
